<template>
  <el-container class="carOutDetial">
    <el-tabs class="tabs-box" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="信息" name="one">
        <div class="table-box">
          <h-table
            ref="tableRef"
            v-model:data="tableData"
            v-model:columns="columns"
            :method="facecrouchDetail"
            :params="params"
            @handleClick="handleClick"
            @select="hzTableSelect"
          >
            <template #imageUrl="{ row }">
              <div class="table-role" @click="bigPicture(row.imageUrl)">
                <img v-if="row.imageUrl" :src="row.imageUrl" />
                <img v-else src="~@/assets/images/moren.png" />
              </div>
            </template>
            <template #snapTime="{ row }">
              <span>
                {{ moment(row.snapTime).format("YYYY-MM-DD HH:mm:ss") }}
              </span>
            </template>
            <template #similarity="{ row }">
              <div class="table-role">
                {{ row.similarity + "%" }}
              </div>
            </template>
            <template #type="{ row }">
              <div class="table-role">
                <span>{{ row.type == "2" ? "昼出" : "夜出" }}</span>
              </div>
            </template>
          </h-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="统计" name="two">
        <outNightEchart
          v-if="activeName == 'two'"
          type="face"
          :params="params"
        ></outNightEchart>
      </el-tab-pane>
    </el-tabs>
  </el-container>
  <h-big-picture
    :pictureUrl="pictureUrl"
    v-model:visible="bigPictureVisible"
  ></h-big-picture>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  nextTick,
  watch,
} from "vue";

import { facecrouchDetail } from "@/api/publicSecurityResearch/keyCarPerson.js";

import outNightEchart from "../../../components/outNightEchart.vue";
import moment from "moment";

// import _ from "lodash";
export default defineComponent({
  name: "carOutDetial",
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    colorDict: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { outNightEchart },
  setup(props) {
    const state = reactive({
      formVisible: false,
      columns: [
        { type: "selection", show: false },
        { type: "index" },
        {
          label: "抓拍图",
          slot: "imageUrl",
        },
        {
          label: "相似度",
          slot: "similarity", // sex
        },
        {
          label: "抓拍卡口",
          prop: "deviceName",
        },
        {
          label: "昼伏夜出",
          slot: "type",
        },
        {
          label: "抓拍时间",
          slot: "snapTime", // nation
        },
      ],
      chartData: [],
      chartX: [],
      chartDayY: [],
      chartNightY: [],
      pictureUrl: null,
      bigPictureVisible: false,
    });
    const refData = toRefs(state);
    const tableRef = ref(null);
    const formRef = ref(null);
    const activeName = ref("one");
    watch(
      () => {
        props.params;
      },
      () => {
        nextTick(() => {
          activeName.value = "one";
          tableRef.value && tableRef.value.refresh();
        });
      },
      { deep: true, immediate: true }
    );

    const bigPicture = (url) => {
      console.log(url);
      state.pictureUrl = url;
      state.bigPictureVisible = true;
    };
    return {
      ...refData,
      tableRef,
      formRef,
      activeName,
      bigPicture,
      moment,
      facecrouchDetail,
    };
  },
});
</script>
<style lang="scss" scoped>
.carOutDetial {
  height: 60vh;
  width: 100%;
  .el-tabs {
    width: 100%;
    height: 100%;
  }
  .table-box {
    width: 100%;
    height: 100%;
    img {
      width: 114px;
      height: 67px;
    }
  }
  .el-tab-pane {
    width: 100%;
    height: 100%;
    #echartsTopLeft {
      width: 1000px;
      height: 500px;
    }
  }
  // #echartsTopLeft {
  //   width: 100%;
  //   height: 100%;
  // }
}
</style>
